import { monthListShortTH, monthListTH } from "src/context/constants/datetime";
import { ERROR_CODE } from "src/context/constants/errorCode";
import { errorType } from "src/types/error-types";

export function validateEmail(email: string) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

export function zeroPad(num: number, numZeros: number) {
  var n = Math.abs(num);
  var zeros = Math.max(0, numZeros - Math.floor(n).toString().length);
  var zeroString = Math.pow(10, zeros).toString().substr(1);
  if (num < 0) {
    zeroString = "-" + zeroString;
  }

  return zeroString + n;
}

export const capitalize = (val: string | undefined) => {
  if (val) {
    return val[0].toUpperCase() + val.slice(1).toLowerCase();
  } else return "";
};

export const copyToClipboard = (content: any) => {
  const el = document.createElement("textarea");
  el.value = content;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export const isEmailValid = (email: string) => {
  return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
    email
  );
};

export function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function isObjEquivalent(a: any, b: any) {
  // Create arrays of property names
  var aProps = Object.getOwnPropertyNames(a);
  var bProps = Object.getOwnPropertyNames(b);

  // If number of properties is different,
  // objects are not equivalent
  if (aProps.length !== bProps.length) {
    return false;
  }

  for (var i = 0; i < aProps.length; i++) {
    var propName = aProps[i];

    // If values of same property are not equal,
    // objects are not equivalent
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  // If we made it this far, objects
  // are considered equivalent
  return true;
}

export function setCookie(name: string, value: any, days: number) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name: string) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const getBase64Cookie = (name: string) => {
  name = Buffer.from(name).toString("base64");
  name = name.slice(0, 8) + name.slice(-4);

  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  var value = "";
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) {
      value = c.substring(nameEQ.length, c.length);
      return Buffer.from(value, "base64").toString("ascii");
    }
  }
  return null;
};

export function eraseCookie(name: string) {
  document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

export const haveEmoji = (text: string) => {
  if (!text) return false;
  // const emojiMatch = text.match(/\p{Emoji}/gu)
  // if (!emojiMatch) return false
  // return emojiMatch.length > 0
  const alphabetRegex = /^[a-z|A-Z|0-9|ก-ฮ|\u0E2F-\u0E3A|\u0E3F-\u0E5B|\s]+$/;
  return !alphabetRegex.test(text);
  // return (/(?:[\u00A9\u00AE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9-\u21AA\u231A-\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA-\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614-\u2615\u2618\u261D\u2620\u2622-\u2623\u2626\u262A\u262E-\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665-\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B-\u269C\u26A0-\u26A1\u26AA-\u26AB\u26B0-\u26B1\u26BD-\u26BE\u26C4-\u26C5\u26C8\u26CE-\u26CF\u26D1\u26D3-\u26D4\u26E9-\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733-\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934-\u2935\u2B05-\u2B07\u2B1B-\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|(?:\uD83C[\uDC04\uDCCF\uDD70-\uDD71\uDD7E-\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01-\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50-\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96-\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F-\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95-\uDD96\uDDA4-\uDDA5\uDDA8\uDDB1-\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB-\uDEEC\uDEF0\uDEF3-\uDEF6]|\uD83E[\uDD10-\uDD1E\uDD20-\uDD27\uDD30\uDD33-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4B\uDD50-\uDD5E\uDD80-\uDD91\uDDC0]))/.test(text))
};

export const haveLowercase = (text: string) => {
  if (!text) return false;
  return /[a-z]/.test(text);
};

export const haveUppercase = (text: string) => {
  if (!text) return false;
  return /[A-Z]/.test(text);
};

export const haveNumber = (text: string) => {
  if (!text) return false;
  return /[0-9]/.test(text);
};

export const haveSymbol = (text: string) => {
  if (!text) return false;
  return /[_\W]/.test(text);
};

export const toThaiMonth = (monthTH: string | number, short?: boolean) => {
  let _month = 0;
  if (!monthTH && monthTH !== 0) return "";
  if (typeof monthTH === "string") _month = parseInt(monthTH);
  if (typeof monthTH === "number") _month = monthTH;
  if (_month < 0 || _month > 12) return "";
  return short ? monthListShortTH[_month] : monthListTH[_month];
};

export const dateDiffInDay = (_startDate: Date, _endDate: Date) => {
  if (!_startDate) return 0;
  if (!_endDate) return 0;
  const duration = Math.abs(_endDate.getTime() - _startDate.getTime());
  return Math.ceil(duration / (24 * 3600 * 1000));
};

export const dateDiffInMonth = (_startDate: Date, _endDate: Date) => {
  if (!_startDate) return 0;
  if (!_endDate) return 0;
  var d1Y = _startDate.getFullYear();
  var d2Y = _endDate.getFullYear();
  var d1M = _startDate.getMonth();
  var d2M = _endDate.getMonth();

  return d2M + 12 * d2Y - (d1M + 12 * d1Y);
};

export const dateDiffInYear = (_startDate: Date, _endDate: Date) => {
  if (!_startDate) return 0;
  if (!_endDate) return 0;
  var d1Y = _startDate.getFullYear();
  var d2Y = _endDate.getFullYear();

  return d2Y - d1Y;
};

// export const dateDiff = (_startDate:string,_endDate:string) => {
//   if (!_startDate) return ""
//   if (!_endDate) return ""
//   const startDate = new Date(_startDate)
//   const endDate = new Date(_endDate)
//   const day = dateDiffInDay(startDate,endDate)
//   const month = dateDiffInMonth(startDate,endDate)
//   const year = dateDiffInYear(startDate,endDate)

//   return `${day} วัน ${month%12} เดือน ${year} ปี`
// }

export const dateDiff = (startingDate: string, endingDate: string) => {
  var startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));
  if (!endingDate) {
    endingDate = new Date().toISOString().substr(0, 10); // need date in YYYY-MM-DD format
  }
  var endDate = new Date(endingDate);
  if (startDate > endDate) {
    var swap = startDate;
    startDate = endDate;
    endDate = swap;
  }
  var startYear = startDate.getFullYear();
  var february =
    (startYear % 4 === 0 && startYear % 100 !== 0) || startYear % 400 === 0
      ? 29
      : 28;
  var daysInMonth = [31, february, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  var yearDiff = endDate.getFullYear() - startYear;
  var monthDiff = endDate.getMonth() - startDate.getMonth();
  if (monthDiff < 0) {
    yearDiff--;
    monthDiff += 12;
  }
  var dayDiff = endDate.getDate() - startDate.getDate();
  if (dayDiff < 0) {
    if (monthDiff > 0) {
      monthDiff--;
    } else {
      yearDiff--;
      monthDiff = 11;
    }
    dayDiff += daysInMonth[startDate.getMonth()];
  }

  // return yearDiff + 'Y ' + monthDiff + 'M ' + dayDiff + 'D';
  // return `${dayDiff} วัน ${monthDiff%12} เดือน ${yearDiff} ปี`
  let formDateString = "";
  if (yearDiff > 0) formDateString += `${yearDiff} ปี`;
  if (monthDiff % 12 > 0) formDateString += ` ${monthDiff % 12} เดือน`;
  if (monthDiff % 12 === 0 && yearDiff === 0)
    formDateString += `${dayDiff} วัน`;
  if (monthDiff % 12 === 0 && yearDiff === 0 && dayDiff === 0)
    formDateString += `${dayDiff} วัน`;
  return formDateString;
};

export const toThaiDateFormat = (_date: string, short?: boolean) => {
  if (!_date) return "";
  const date = new Date(_date);
  if (short)
    return `${date.getDate()} ${toThaiMonth(date.getMonth(), true)} ${
      date.getFullYear() + 543
    }`;
  return `${date.getDate()} ${toThaiMonth(date.getMonth())} ปี ${
    date.getFullYear() + 543
  }`;
};

export const toThaiTimeFormat = (_date: string, isCountup?: boolean) => {
  if (!_date) return "";
  const date = new Date(_date);
  if (isCountup) {
    var countDownDate = date.getTime();
    var x = setInterval(function () {
      var now = new Date().getTime();

      var distance = countDownDate - now;

      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      return `${days} วัน ${hours} ชั่วโมง ${minutes} นาที ${seconds} วินาที`;
      if (distance < 0) {
        clearInterval(x);
      }
    }, 1000);
  }
  return `${date.getDate()} วัน ${date.getHours()} ชั่วโมง ${date.getMinutes()} นาที ${date.getSeconds()} วินาที`;
};

export const isAfterToday = (_date: string) => {
  if (!_date) return false;
  const startRunDate = new Date(_date).setHours(0, 0, 0, 0);
  const today = new Date().setHours(0, 0, 0, 0);
  if (startRunDate > today) return true;
  return false;
};

export const makeError = (message: string = "", code: string = "") => {
  const error: errorType = {
    __typename: "Error",
    message: message || "พบข้อผิดพลาด กรุณาลองใหม่อีกครั้ง",
    code: code || ERROR_CODE.FRONT_INTERNAL,
  };
  return error;
};

export async function sha256(message: string) {
  // encode as UTF-8
  const msgBuffer = new TextEncoder().encode(message);

  // hash the message
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

  // convert ArrayBuffer to Array
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  // convert bytes to hex string
  const hashHex = hashArray
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
  return hashHex;
}

export function readDefaultBroker() {
  return process.env.REACT_APP_BROKER_NAME;
}

export function andConditions(...conditions: any[]) {
  return conditions.reduce((prev, current) => prev && Boolean(current), true);
}

export function randomIntFromInterval(min: number, max: number) {
  // min and max included
  return Math.floor(Math.random() * (max - min + 1) + min);
}

export function arrayIntFromZeroToTarget(target: number) {
  // min and max included
  return Array.from(Array(target).keys());
}

export function fullnameWrapper(fullname: string) {
  let name = fullname.split(" ");
  if (name.length === 2)
    return `${capitalize(name[0])} ${name[1][0].toUpperCase()}.`;
  return fullname;
}

export function levenshtein(a: string, b: string) {
  if (a.length == 0) return b.length;
  if (b.length == 0) return a.length;

  // swap to save some memory O(min(a,b)) instead of O(a)
  if (a.length > b.length) {
    var tmp = a;
    a = b;
    b = tmp;
  }

  var row = [];
  // init the row
  for (var i = 0; i <= a.length; i++) {
    row[i] = i;
  }

  // fill in the rest
  for (var i = 1; i <= b.length; i++) {
    var prev = i;
    for (var j = 1; j <= a.length; j++) {
      var val;
      if (b.charAt(i - 1) == a.charAt(j - 1)) {
        val = row[j - 1]; // match
      } else {
        val = Math.min(
          row[j - 1] + 1, // substitution
          prev + 1, // insertion
          row[j] + 1
        ); // deletion
      }
      row[j - 1] = prev;
      prev = val;
    }
    row[a.length] = prev;
  }

  return row[a.length];
}

export function hexToRGB(hex: string, alpha: number) {
  var r = parseInt(hex.slice(1, 3), 16),
    g = parseInt(hex.slice(3, 5), 16),
    b = parseInt(hex.slice(5, 7), 16);

  if (alpha) {
    return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
  } else {
    return "rgb(" + r + ", " + g + ", " + b + ")";
  }
}

hexToRGB("#FF0000", 0.5);

export const getCurrency = (symbol: string | undefined) => {
  try {
    if (symbol) {
      let symbolArr = symbol.split("_");
      if (symbolArr[0] === "THB") return symbolArr[1];
      if (symbolArr[1] === "THB") return symbolArr[0];
      return "UNK";
    }
    return "UNK";
  } catch (_) {
    return "UNK";
  }
};

export const isMobilePlatform = () => {
  return (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) ||
    /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.platform)
  );
  // return true;
};

export const getTextValueRepresentColor = (val?: number) => {
  if (!val) return "textSecondary";
  if (val > 0) return "primary";
  if (val < 0) return "secondary";
  return "textPrimary";
};

export const getTextValueBuySellColor = (side?: string) => {
  if (!side) return "textSecondary";
  if (side.toLowerCase() === "buy") return "primary";
  if (side.toLowerCase() === "sell") return "secondary";
  return "textPrimary";
};

export function placeCaretAtEnd(el: any) {
  el.focus();
  if (
    typeof window.getSelection != "undefined" &&
    typeof document.createRange != "undefined"
  ) {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);
    //@ts-ignore
  } else if (typeof document.body.createTextRange != "undefined") {
    //@ts-ignore
    var textRange = document.body.createTextRange();
    textRange.moveToElementText(el);
    textRange.collapse(false);
    textRange.select();
  }
}

export const timeFreqLabel = (timeFreq: string | undefined) => {
  if (!timeFreq) return " - ";

  const timeValue = timeFreq.slice(0, -1);
  const timeUnit = timeFreq[timeFreq.length - 1];

  switch (timeUnit) {
    case "m":
      return `${timeValue} นาที`;
    case "h":
      return `${timeValue} ชั่วโมง`;
    case "d":
      return `${timeValue} วัน`;
    default:
      return " - ";
  }
};
